var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="chart_sec">\n    ';
 if ( navigation ) { 
__p+='\n    <a class="left carousel-control">\n        <span class="glyphicon glyphicon-chevron-left"></span>\n    </a>\n    ';
 } 
__p+='\n\n    <div class="chartjs-container">\n        <div class="chartjs-canvas-container">\n            <canvas class="chartjs-canvas"></canvas>\n        </div>\n    </div>    \n    ';
 if ( navigation ) { 
__p+='\n        <a class="right carousel-control">\n            <span class="glyphicon glyphicon-chevron-right"></span>\n        </a>\n    ';
 } 
__p+='\n\n    <div class="no_data">\n        <img src="https://asset.land-fx.com/land/common/inbox_icon.png" alt="no data"/>\n        <div>No data</div>\n    </div>\n    <div class="loading-spinner-container">\n        <div class="loading-spinner"></div>\n    </div>\n</div>';
}
return __p;
};
